"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
const jobsharingCompanies = ["Energie-Pensions-Management GmbH", "E.ON Group Innovation GmbH", "E.ON Country Hub Germany GmbH", "E.ON Accounting Solutions GmbH", "E.ON Stiftung gGmbH", "E.ON Gastronomie GmbH", "E.ON impulse GmbH", "E.ON SE"];
export const isJobSharing = (job: {
  data: {
    employmentType: string | string[];
  };
}) => Array.isArray(job.data.employmentType) ? job.data.employmentType.includes("Jobsharing") || job.data.employmentType.includes("Job sharing") : job.data.employmentType.toLowerCase() === "jobsharing" || job.data.employmentType.toLowerCase() === "job sharing";
export default function JobSharing(t0) {
  const $ = _c(35);
  const {
    job
  } = t0;
  const t = useLanguage();
  const jobsharingApplyUrl = `https://pairtoshare.com/job-redirect?companyId=119da067-0895-4569-8857-8f77735f3bb9&jobId=${job.data.idClient}`;
  if (!(jobsharingCompanies.includes(job.data.company) && isJobSharing(job))) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundImage: `url(${process.env.NEXT_PUBLIC_ASSET_URL}images/jobad/about-bg.webp)`,
      backgroundSize: "cover"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t.jobsharingHL) {
    t2 = <h3 className="mb-4 font-bold text-2xl text-primary md:text-4xl">{t.jobsharingHL}</h3>;
    $[1] = t.jobsharingHL;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t.jobsharing_intro) {
    t3 = <p className="mb-6 text-gray-700">{t.jobsharing_intro}</p>;
    $[3] = t.jobsharing_intro;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t.jobsharing_benefitsHL) {
    t4 = <h4 className="mb-2 font-bold text-foreground">{t.jobsharing_benefitsHL}</h4>;
    $[5] = t.jobsharing_benefitsHL;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t.jobsharing_benefits) {
    t5 = <ul className="ml-5 list-outside list-disc text-gray-700" dangerouslySetInnerHTML={{
      __html: t.jobsharing_benefits
    }} />;
    $[7] = t.jobsharing_benefits;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="bg-gray-100 p-4">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t.jobsharing_howToHL) {
    t7 = <h4 className="mb-2 font-bold text-foreground">{t.jobsharing_howToHL}</h4>;
    $[12] = t.jobsharing_howToHL;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t.jobsharing_howTo) {
    t8 = <ul className="ml-5 list-outside list-disc text-gray-700" dangerouslySetInnerHTML={{
      __html: t.jobsharing_howTo
    }} />;
    $[14] = t.jobsharing_howTo;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <div className="bg-gray-100 p-4">{t7}{t8}</div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2">{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== jobsharingApplyUrl || $[23] !== t.jobsharing_applyButton) {
    t11 = <div className="mt-8 text-center"><CustomLink blank={true} className="mr-auto rounded-lg bg-primary px-4 py-2 font-medium text-white transition-all duration-300 hover:bg-secondary hover:text-white md:w-auto" href={jobsharingApplyUrl}>{t.jobsharing_applyButton}</CustomLink></div>;
    $[22] = jobsharingApplyUrl;
    $[23] = t.jobsharing_applyButton;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t2 || $[28] !== t3) {
    t12 = <div className="grid h-full w-full max-w-screen-xl gap-10 bg-white p-6 text-lg"><div className="flex flex-col items-center gap-2"><div className="w-full bg-white p-8">{t2}{t3}{t10}{t11}</div></div></div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t2;
    $[28] = t3;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t.jobsharing_fixedButton) {
    t13 = <a className="fixed right-0 bottom-40 z-10 flex h-12 w-16 items-center justify-center hyphens-auto rounded-l-md bg-secondary p-2 text-center font-medium text-sm text-white md:bottom-48 md:h-20 md:w-20 md:text-base" dangerouslySetInnerHTML={{
      __html: t.jobsharing_fixedButton
    }} href="#jobsharing" />;
    $[30] = t.jobsharing_fixedButton;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t12 || $[33] !== t13) {
    t14 = <section className="flex w-full justify-center pointer-fine:bg-fixed px-10 py-10 text-foreground md:px-10 md:py-20 print:hidden" id="jobsharing" style={t1}>{t12}{t13}</section>;
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
}